<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  created() {
    if (window.localStorage.getItem('store')) {
      let store = JSON.parse(window.localStorage.getItem('store'))
      console.log(store)
      let state = {
        'historyList': store.historyList,
        'navigationName': store.navigationName,
        'token': store.token,
        'userInfo': store.userInfo,
        'likeMsg': store.likeMsg,
        'commentMsg': store.commentMsg,
        'chatList': store.chatList,
        'msgList': store.msgList
      }
      this.$store.replaceState(Object.assign({},this.$store.state,state))
      if(this.$store.state.token){
        this.$socket.io.opts.query = {
          token: this.$store.state.token
        }
        this.$socket.open()
      }
    }
    window.addEventListener('beforeunload', () => {
      window.localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    window.addEventListener('unload', () => {
      window.localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  watch : {
    '$route' (to, from) {
      this.$store.commit("set_router_url", to.name)
    }
  },
  components: {
  },
  mounted() {
    
  },
  methods: {

  }
}
</script>

<style>
body,html,#app{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
 /* 隐藏标准的滚动条 */
 /* html::-webkit-scrollbar {
    width: 0;
  }
  body::-webkit-scrollbar {
    width: 0;
  } */
  /* 隐藏 IE 和 Edge 浏览器的滚动条 */
  /* ::-ms-scrollbar {
    width: 0;
  } */
  
.el-input__inner:focus {
  border-color: #dcdfe6 !important;
}
.el-input__inner {
  border: 1px solid #dcdfe6;
}
.el-input__inner:hover {
  border-color: #dcdfe6;
}
.second_item_comment_input .el-input__inner {
  background: #F6F6F6;
  border: 0px solid #dcdfe6;
  height: 57px;
  line-height: 57px;
  font-size: 16px;
  font-weight: 400;
  padding: 0 21px;
}
.second_item_comment_input input::-webkit-input-placeholder {
  color: #333;
}
.body_right_second_feedback_textarea .el-textarea__inner{
  height: 100%;
  border: 0px solid #dcdfe6;
  font-size: 16px;
  font-weight: 300;
  color: #000;
  line-height: 24px;
  padding: 19px 23px;
}

</style>
